
export { AdvancedNewsManager } from "/builds/benzinga/fusion/libs/data/manager/advanced-news/src/manager.ts"